import React from "react"

import { IOneVerifyCoverageResult } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import { COVERAGE_CONFIG } from "../../config/coverage.config"
import { HtmlHelper } from "../../helpers/html.helper"

export const CheckTypeBadgeElement: React.FunctionComponent<{
    coverageResult: IOneVerifyCoverageResult
}> = props => {
    return HtmlHelper.getHtmlWrappedBadge(
        "Check Type: " +
            COVERAGE_CONFIG.responseTypeMapping[
                props.coverageResult.responseType
            ],
        undefined,
        undefined,
        undefined,
        "bg-brand-lilacLight border-brand-lilac",
    )
}
